import ApiServer from '@/utils/api/ApiServer.js'
import store from '@/store'

const paths = (scaleSheetId, childPath) => {
  const path = {
    getAll: 'scalesheetprofiles',
    create: 'scalesheetprofiles',
    update: `scalesheetprofiles/${scaleSheetId}`,
    delete: `scalesheetprofiles/${scaleSheetId}`,
    tractProfiles: `scalesheetprofiles/${scaleSheetId}/tractprofiles`,
    profileMappings: `scalesheetprofiles/${scaleSheetId}/${childPath}`
  }
  return path
}

export default {
  async fetchProfiles (context) {
    try {
      context.commit('setLoading', true)
      const response = await ApiServer.get(paths(null).getAll)
      context.commit('setScaleSheetProfiles', response.data)
    } finally {
      context.commit('setLoading', false)
    }
  },

  async createProfile (context, profileData) {
    try {
      context.commit('setLoading', true)
      const response = await ApiServer.post(paths(null).create, profileData)
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async updateProfile (context, profileData) {
    try {
      context.commit('setLoading', true)
      const response = await ApiServer.put(paths(profileData.scaleSheetImportProfileId).update, profileData)
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async createTractProfile (context, { scaleSheetImportProfileId, externalTractName, tractId }) {
    try {
      context.commit('setLoading', true)
      const response = await ApiServer.post(paths(scaleSheetImportProfileId).tractProfiles, { externalTractName, tractId })
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async createProfileMapping (context, { scaleSheetImportProfileId, childPath, ...mapping }) {
    try {
      context.commit('setLoading', true)
      const response = await ApiServer.post(paths(scaleSheetImportProfileId, childPath).profileMappings, mapping)
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async deleteProfile (context, id) {
    try {
      context.commit('setLoading', true)
      await ApiServer.delete(paths(id).delete)
      context.commit('setScaleSheetProfiles', context.getters.scaleSheetProfiles.filter(profile => profile.id !== id))
    } finally {
      context.commit('setLoading', false)
    }
  },

  async createScaleSheetEmailRequest (context, { accountId, accountContactId }) {
    const dateConfiguration = store.getters['settlements/dateConfiguration']
    const { exportBatch, payPeriod } = dateConfiguration
    const url = ApiServer.urlFor(`payPeriods/${payPeriod.payPeriodId}/exportBatches/${exportBatch.exportBatchId}/volumedataemailrequest`, { version: 2 })
    const response = await ApiServer.post(url, { accountId, accountContactId })
    return response.data
  }
}
